import { SET_MEDICINES, REMOVE_MEDICINES, FILTER_MEDICINES } from './types'

import {newMedicines} from '../../testData/testMedicines'

export function filterMedicines (pathologiesId) {
  const data = []
  pathologiesId.forEach(pathologyId => {
    const filtered = newMedicines.filter(m => m.targetDiseases.includes(pathologyId))
    data.push(...filtered)
  })
  return {
    type: FILTER_MEDICINES,
    payload: {
      targetDiseases: pathologiesId,
      data
    }
  }
}

export function setMedicines () {
  return {
    type: SET_MEDICINES,
    payload: newMedicines
  }
}

export function removeMedicines () {
  return {
    type: REMOVE_MEDICINES
  }
}
